import type {RefObject} from 'react'
import {Dialog} from '@primer/react/experimental'
import type {GettingStarted} from '../../../../types'
import {CodeContainer} from './CodeContainer'
import styles from './GettingStartedDialog.module.css'
import type {ModelPersistentUIState} from '../../../../utils/playground-local-storage'

export interface GettingStartedDialogProps {
  onClose: () => void
  gettingStarted: GettingStarted
  modelName: string
  uiState?: ModelPersistentUIState
  setUiState?: (uiState: ModelPersistentUIState) => void
  returnFocusRef?: RefObject<HTMLElement>
}

export default function GettingStartedDialog({
  onClose,
  gettingStarted,
  modelName,
  uiState,
  setUiState,
  returnFocusRef,
}: GettingStartedDialogProps) {
  return (
    <Dialog
      returnFocusRef={returnFocusRef}
      title="Get started with Models in your codebase"
      position={{narrow: 'fullscreen', regular: 'center'}}
      onClose={onClose}
      className={styles.gettingStartedDialog}
      renderBody={() => {
        return (
          <CodeContainer
            gettingStarted={gettingStarted}
            modelName={modelName}
            uiState={uiState}
            setUiState={setUiState}
          />
        )
      }}
    />
  )
}

try{ GettingStartedDialog.displayName ||= 'GettingStartedDialog' } catch {}